import MissingInputError from '@/errors/MissingInputError';
import LibertyLensForm from '../LibertyLensForm';

export default class GenericLensGenerator
{
    /**
     * Check for missing required input parameters.
     *
     * @param {Record<string, any>} params The input parameters with code as keys.
     * @returns {boolean}
     * @throws {MissingInputError}
     */
    checkInput(params)
    {
        const name = this.constructor.name;
        throw new Error(`${name}.checkInput(): method not implemented`);
    }

    /**
     * Generate the generic lens from the input parameters.
     *
     * @param {Record<string, any>} params The input parameters with code as keys.
     * @returns {LibertyLensForm}
     */
    generate(params)
    {
        const name = this.constructor.name;
        throw new Error(`${name}.generate(): method not implemented`);
    }
}
